import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import AddCategory from "../../Modals/addCategory";
import { isValidInput } from "../../utils/validations";
import usePagination from "@mui/material/usePagination/usePagination";
import usePermission from "../../hooks/usePermission";

type props = {
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setSelectedName: Dispatch<SetStateAction<string>>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  setError: Dispatch<SetStateAction<boolean>>;
  searchTerm: string;
};

const CategoryTopbar = ({
  setOpen,
  setSelectedId,
  setSelectedName,
  setError,
  searchTerm,
  setDebouncedSearchTerm,
  setSearchTerm,
}: props) => {
  const {isAdd}=usePermission({label:"Manage Categories",page_permission:"isView"})
  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        <div className="right_s">
         {isAdd && <Button
            className="btn btn_primary"
            onClick={() => {
              setOpen(true);
              setSelectedName("");
              setSelectedId("");
              setError(false);
            }}
          >
            <AddIcon /> Add
          </Button>}
        </div>
      </div>
    </>
  );
};

export default CategoryTopbar;
